import "./assets/css/index.css";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import WebRoutes from "./routes";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Main App
function App() {
  return (
    <>
      <Toaster position="top-right" />
      <Routes>
        <Route path="/*" element={<WebRoutes />} />
      </Routes>
    </>
  );
}

function AppInitializer() {
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}

// Render root
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<AppInitializer />);
